import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';

export type IndexParams = {
  nmls?: string;
  agent_role: string[];
  loan_purpose?: string;
  loan_type: string[];
  real_estate_company: string[];
  page: number;
  limit: number;
  sort_field?: string;
  order?: Order;
  realtor_id: string;
  companyLicense?: string;
  period: Period;
  export_team_data?: boolean;
};

export const index = async (params: IndexParams) => {
  const agentRoleFilters = params.agent_role
    ?.map((agentRole) => `&filter[agent_type][]=${agentRole}`)
    .join('');

  const loanTypeFilters = params.loan_type
    ?.map((loanType) => `&filter[loan_type][]=${loanType}`)
    .join('');

  const realEstateCompanyFilters = params.real_estate_company
    ?.map((realEstateCompany) => `&filter[real_estate_company][]=${realEstateCompany}`)
    .join('');

  return apiClient.get(
    `/loan_transactions?${agentRoleFilters}${loanTypeFilters}${realEstateCompanyFilters}`,
    {
      params: {
        'filter[loan_purpose]': params.loan_purpose,
        'sort[field]': params.sort_field,
        'sort[order]': params.order,
        period: params.period,
        page: params.page,
        limit: params.limit,
        loan_officer_nmls: params.nmls,
        company_license: params.companyLicense,
        realtor_id: params.realtor_id,
        export_team_data: params.export_team_data,
      },
    }
  );
};
